{
  "limits": {
    "overlay": {
      "title": {
        "customColoursOnModels": "Custom Colours on Models"
      },
      "content": {
        "text1": {
          "customColoursOnModels": "You currently do not have access to add custom colours to your 3D models. Upgrade to work on plans collaboratively with other team members.",
          "customSharedPlanExpiryDuration": "Upgrade to set custom expiry durations for shared links."
        }
      }
    }
  }
}